import { render, staticRenderFns } from "./ResolDeltaThermPv_1d04.vue?vue&type=template&id=5f6348f0&"
import script from "./ResolDeltaThermPv_1d04.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaThermPv_1d04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports